import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as felaRules from './Cookies.rules';
import Title, { TitleTypes } from '../../../Title';
import Text, { TextTypes } from '../../../Text';
import { DynamicContainer } from '../../../Layout/DynamicContainer';
import CustomFormattedHTMLMessage from '../../../CustomFormattedHTMLMessage';
import { useFelaEnhanced } from '@ackee/fela';

const Cookies = () => {
    const { styles, rules } = useFelaEnhanced(felaRules);

    return (
        <>
            {/* @ts-expect-error */}
            <Title columns={8} type={TitleTypes.H1} as={TitleTypes.H2} extend={rules.extendTitle}>
                <FormattedMessage id="modal.cookies.title" />
            </Title>
            <DynamicContainer columns={6}>
                {/* @ts-expect-error */}
                <Text as="p" type={TextTypes.LARGE}>
                    <FormattedMessage id="modal.cookies.firstParagraph" />
                </Text>
                {/* @ts-expect-error */}
                <Text as="h3" type={TextTypes.LARGE}>
                    <b>
                        <FormattedMessage id="modal.cookies.subtitle" />
                    </b>
                </Text>
                {/* @ts-expect-error */}
                <Text as="p" type={TextTypes.LARGE}>
                    <CustomFormattedHTMLMessage id="modal.cookies.secondParagraph" />
                </Text>
                <a
                    className={styles.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage"
                >
                    <FormattedMessage id="modal.cookies.linkText" />
                </a>
            </DynamicContainer>
        </>
    );
};

export default Cookies;
